import { render, staticRenderFns } from "./PagePaymentDecline.vue?vue&type=template&id=ccb30e76&scoped=true&"
import script from "./PagePaymentDecline.vue?vue&type=script&lang=js&"
export * from "./PagePaymentDecline.vue?vue&type=script&lang=js&"
import style0 from "./PagePaymentDecline.vue?vue&type=style&index=0&id=ccb30e76&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb30e76",
  null
  
)

export default component.exports